"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBar = void 0;
const styles_1 = require("@mui/material/styles");
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const AppBar = (0, styles_1.styled)(AppBar_1.default, {
    shouldForwardProp: (prop) => prop !== 'open' || 'drawerWidth' || 'anchor',
})(({ theme, open, drawerWidth, anchor }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            props: open,
            style: {
                width: open ? `calc(100% - ${drawerWidth}px)` : '100%',
                transition: theme.transitions.create(['margin', 'width'], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                marginRight: anchor === 'right' && open ? drawerWidth : 'unset',
                marginLeft: anchor === 'left' && open ? drawerWidth : 'unset',
                backgroundColor: theme.palette.gray[500],
            },
        },
    ],
}));
exports.AppBar = AppBar;
//# sourceMappingURL=AppBar.js.map